import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Language } from '@model/language';
import { TranslatorService } from '@service/translator/translator.service';
import { UserSettingsStorage } from '@storage/settings/user-settings.storage';

@Component({
  selector: 'app-language',
  templateUrl: './language.component.html'
})
export class LanguageComponent implements OnInit {
  languages: Language[];
  selectedLanguage: Language;
  @Output() isSelected = new EventEmitter();
  @Input() syncable: boolean = false;
  @Input() isDefaultLanguages: boolean = false;
  @Input() theme: string;

  constructor(
    public storage: UserSettingsStorage,
    public translatorService: TranslatorService
  ) { }

  ngOnInit(): void {
    this.getLanguages();
    this.setSelectedLanguage();
  }

  setSelectedLanguage(): void {
    let userLanguage = (this.translatorService.getUsersSelectedLanguage() || 'tr');
    if (this.isDefaultLanguages) {
      userLanguage = this.translatorService.isOneOfDefaultLanguages(userLanguage) ? userLanguage : 'en';
    }
    this.selectedLanguage = this.translatorService.getLanguage(userLanguage);
  }

  getLanguages() {
    this.languages = this.isDefaultLanguages ? this.translatorService.getDefaultLanguages() : this.translatorService.getAvailableLanguages();
  }

  setLanguage(value: string): void {
    if (this.syncable) {
      this.isSelected.emit(value);
    } else {
      this.translatorService.useLanguage(value);
      this.storage.setTranslateLanguage(value);
    }
    this.selectedLanguage = this.translatorService.getLanguage(value);
  }
}
